export var convertSyncBlockPMNodeToSyncBlockData = function convertSyncBlockPMNodeToSyncBlockData(node) {
  return {
    blockInstanceId: node.attrs.localId,
    content: node.content.toJSON(),
    resourceId: node.attrs.resourceId
  };
};
export var createSyncBlockNode = function createSyncBlockNode(localId, resourceId) {
  return {
    type: 'syncBlock',
    attrs: {
      localId: localId,
      resourceId: resourceId
    }
  };
};
export var createBodiedSyncBlockNode = function createBodiedSyncBlockNode(localId, resourceId) {
  return {
    type: 'bodiedSyncBlock',
    attrs: {
      localId: localId,
      resourceId: resourceId
    }
  };
};
export var convertSyncBlockJSONNodeToSyncBlockNode = function convertSyncBlockJSONNodeToSyncBlockNode(node) {
  if (node.type !== 'syncBlock' || !node.attrs || !('localId' in node.attrs) || !('resourceId' in node.attrs) || typeof node.attrs.localId !== 'string' || typeof node.attrs.resourceId !== 'string') {
    return undefined;
  }
  return createSyncBlockNode(node.attrs.localId, node.attrs.resourceId);
};
export var convertPMNodeToSyncBlockNode = function convertPMNodeToSyncBlockNode(node) {
  var _node$attrs, _node$attrs2;
  if (node.type.name !== 'syncBlock' || !((_node$attrs = node.attrs) !== null && _node$attrs !== void 0 && _node$attrs.localId) || !((_node$attrs2 = node.attrs) !== null && _node$attrs2 !== void 0 && _node$attrs2.resourceId) || typeof node.attrs.localId !== 'string' || typeof node.attrs.resourceId !== 'string') {
    return undefined;
  }
  return createSyncBlockNode(node.attrs.localId, node.attrs.resourceId);
};
export var convertPMNodesToSyncBlockNodes = function convertPMNodesToSyncBlockNodes(nodes) {
  return nodes.map(function (node) {
    return convertPMNodeToSyncBlockNode(node);
  }).filter(function (node) {
    return node !== undefined;
  }) || [];
};